// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { BuyItemData, BuyItemResponses, CancelMarketTransactionData, CancelMarketTransactionResponses, ConfirmMarketProfileData, ConfirmMarketProfileResponses, DebugSessionData, DebugSessionResponses, FakeLoginData, FakeLoginResponses, GetBrRankData, GetBrRankResponses, GetCategoriesData, GetCategoriesResponses, GetChannelData, GetChannelResponses, GetCharacterData, GetCharacterHardsData, GetCharacterHardsResponses, GetCharacterResponses, GetCharacterRolesData, GetCharacterRolesResponses, GetCharactersData, GetCharactersResponses, GetCharacterSynergyData, GetCharacterSynergyResponses, GetComboCharactersData, GetComboCharactersResponses, GetCsRankData, GetCsRankResponses, GetFeedbackCategoriesData, GetFeedbackCategoriesResponses, GetGendersData, GetGendersResponses, GetGenresData, GetGenresResponses, GetItemData, GetItemResponses, GetItemsData, GetItemsResponses, GetLanguagesData, GetLanguagesResponses, GetMarketItemsData, GetMarketItemsResponses, GetMarketProfileData, GetMarketProfileResponses, GetMarketRegionData, GetMarketRegionResponses, GetMarketTransactionsData, GetMarketTransactionsResponses, GetMeData, GetMeResponses, GetParamsData, GetParamsResponses, GetPlatformsData, GetPlatformsResponses, GetPrimeLevelData, GetPrimeLevelResponses, GetProfileData, GetProfileResponses, GetRaresData, GetRaresResponses, GetTagsData, GetTagsResponses, GetTransifyData, GetTransifyResponses, GetVaultProfileData, GetVaultProfileResponses, GetVaultRankData, GetVaultRankResponses, GetVaultRanksData, GetVaultRanksResponses, GetWalletData, GetWalletResponses, GetWeaponsData, GetWeaponsResponses, LoginCallbackData, LoginCallbackResponses, LoginData, LoginResponses, ReactData, ReactResponses, RedirectLoginData, RedirectLoginResponses, RedirectLogoutData, RedirectLogoutResponses, SellItemData, SellItemResponses, SubmitFeedbackData, SubmitFeedbackResponses, TimesyncData, TimesyncResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Common params
 */
export const getParams = <ThrowOnError extends boolean = false>(options: Options<GetParamsData, ThrowOnError>) => (options.client ?? client).get<GetParamsResponses, unknown, ThrowOnError>({ url: '/param/{ids}', ...options });

/**
 * Timesync JSON-RPC
 */
export const timesync = <ThrowOnError extends boolean = false>(options: Options<TimesyncData, ThrowOnError>) => (options.client ?? client).post<TimesyncResponses, unknown, ThrowOnError>({
    url: '/timesync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({ url: '/me', ...options });

export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) => (options?.client ?? client).get<GetProfileResponses, unknown, ThrowOnError>({ url: '/me/profile', ...options });

/**
 * Get items
 */
export const getItems = <ThrowOnError extends boolean = false>(options: Options<GetItemsData, ThrowOnError>) => (options.client ?? client).post<GetItemsResponses, unknown, ThrowOnError>({
    url: '/item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get item by id
 */
export const getItem = <ThrowOnError extends boolean = false>(options: Options<GetItemData, ThrowOnError>) => (options.client ?? client).get<GetItemResponses, unknown, ThrowOnError>({ url: '/item/{id}', ...options });

/**
 * React to item
 */
export const react = <ThrowOnError extends boolean = false>(options: Options<ReactData, ThrowOnError>) => (options.client ?? client).post<ReactResponses, unknown, ThrowOnError>({
    url: '/item/{id}/react',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get categories
 */
export const getCategories = <ThrowOnError extends boolean = false>(options?: Options<GetCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetCategoriesResponses, unknown, ThrowOnError>({ url: '/item/category', ...options });

/**
 * Get genres
 */
export const getGenres = <ThrowOnError extends boolean = false>(options?: Options<GetGenresData, ThrowOnError>) => (options?.client ?? client).get<GetGenresResponses, unknown, ThrowOnError>({ url: '/item/genre', ...options });

/**
 * Get rares
 */
export const getRares = <ThrowOnError extends boolean = false>(options?: Options<GetRaresData, ThrowOnError>) => (options?.client ?? client).get<GetRaresResponses, unknown, ThrowOnError>({ url: '/item/rare', ...options });

/**
 * Get genders
 */
export const getGenders = <ThrowOnError extends boolean = false>(options?: Options<GetGendersData, ThrowOnError>) => (options?.client ?? client).get<GetGendersResponses, unknown, ThrowOnError>({ url: '/item/gender', ...options });

/**
 * Get tags
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => (options?.client ?? client).get<GetTagsResponses, unknown, ThrowOnError>({ url: '/item/tag', ...options });

/**
 * Get weapons
 */
export const getWeapons = <ThrowOnError extends boolean = false>(options?: Options<GetWeaponsData, ThrowOnError>) => (options?.client ?? client).get<GetWeaponsResponses, unknown, ThrowOnError>({ url: '/item/weapon', ...options });

/**
 * Get channel
 */
export const getChannel = <ThrowOnError extends boolean = false>(options: Options<GetChannelData, ThrowOnError>) => (options.client ?? client).get<GetChannelResponses, unknown, ThrowOnError>({ url: '/item/channel/{id}', ...options });

export const getBrRank = <ThrowOnError extends boolean = false>(options: Options<GetBrRankData, ThrowOnError>) => (options.client ?? client).get<GetBrRankResponses, unknown, ThrowOnError>({ url: '/game/brRank/{id}', ...options });

export const getCsRank = <ThrowOnError extends boolean = false>(options: Options<GetCsRankData, ThrowOnError>) => (options.client ?? client).get<GetCsRankResponses, unknown, ThrowOnError>({ url: '/game/csRank/{id}', ...options });

export const getPrimeLevel = <ThrowOnError extends boolean = false>(options: Options<GetPrimeLevelData, ThrowOnError>) => (options.client ?? client).get<GetPrimeLevelResponses, unknown, ThrowOnError>({ url: '/game/primeLevel/{id}', ...options });

/**
 * Redirect to login url
 */
export const redirectLogin = <ThrowOnError extends boolean = false>(options?: Options<RedirectLoginData, ThrowOnError>) => (options?.client ?? client).get<RedirectLoginResponses, unknown, ThrowOnError>({ url: '/login', ...options });

/**
 * Login with a token
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
    url: '/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * (Test) Fake a login session
 */
export const fakeLogin = <ThrowOnError extends boolean = false>(options?: Options<FakeLoginData, ThrowOnError>) => (options?.client ?? client).post<FakeLoginResponses, unknown, ThrowOnError>({ url: '/login/fake', ...options });

/**
 * (Test) Debug current session
 */
export const debugSession = <ThrowOnError extends boolean = false>(options?: Options<DebugSessionData, ThrowOnError>) => (options?.client ?? client).get<DebugSessionResponses, unknown, ThrowOnError>({ url: '/login/debug', ...options });

/**
 * Login callback
 */
export const loginCallback = <ThrowOnError extends boolean = false>(options: Options<LoginCallbackData, ThrowOnError>) => (options.client ?? client).get<LoginCallbackResponses, unknown, ThrowOnError>({ url: '/callback', ...options });

/**
 * Redirect to logout url
 */
export const redirectLogout = <ThrowOnError extends boolean = false>(options?: Options<RedirectLogoutData, ThrowOnError>) => (options?.client ?? client).get<RedirectLogoutResponses, unknown, ThrowOnError>({ url: '/logout', ...options });

/**
 * Get all platforms
 */
export const getPlatforms = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformsData, ThrowOnError>) => (options?.client ?? client).get<GetPlatformsResponses, unknown, ThrowOnError>({ url: '/platform', ...options });

export const getTransify = <ThrowOnError extends boolean = false>(options?: Options<GetTransifyData, ThrowOnError>) => (options?.client ?? client).get<GetTransifyResponses, unknown, ThrowOnError>({ url: '/transify', ...options });

export const getLanguages = <ThrowOnError extends boolean = false>(options?: Options<GetLanguagesData, ThrowOnError>) => (options?.client ?? client).get<GetLanguagesResponses, unknown, ThrowOnError>({ url: '/transify/language', ...options });

export const getFeedbackCategories = <ThrowOnError extends boolean = false>(options?: Options<GetFeedbackCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetFeedbackCategoriesResponses, unknown, ThrowOnError>({ url: '/feedback/category', ...options });

export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>) => (options.client ?? client).post<SubmitFeedbackResponses, unknown, ThrowOnError>({
    url: '/feedback/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getVaultRanks = <ThrowOnError extends boolean = false>(options?: Options<GetVaultRanksData, ThrowOnError>) => (options?.client ?? client).get<GetVaultRanksResponses, unknown, ThrowOnError>({ url: '/vault/rank', ...options });

export const getVaultRank = <ThrowOnError extends boolean = false>(options: Options<GetVaultRankData, ThrowOnError>) => (options.client ?? client).get<GetVaultRankResponses, unknown, ThrowOnError>({ url: '/vault/rank/{id}', ...options });

export const getVaultProfile = <ThrowOnError extends boolean = false>(options?: Options<GetVaultProfileData, ThrowOnError>) => (options?.client ?? client).get<GetVaultProfileResponses, unknown, ThrowOnError>({ url: '/vault/profile', ...options });

/**
 * Get character roles
 */
export const getCharacterRoles = <ThrowOnError extends boolean = false>(options?: Options<GetCharacterRolesData, ThrowOnError>) => (options?.client ?? client).get<GetCharacterRolesResponses, unknown, ThrowOnError>({ url: '/char/role', ...options });

/**
 * Get character hards
 */
export const getCharacterHards = <ThrowOnError extends boolean = false>(options?: Options<GetCharacterHardsData, ThrowOnError>) => (options?.client ?? client).get<GetCharacterHardsResponses, unknown, ThrowOnError>({ url: '/char/hard', ...options });

/**
 * Get Characters
 */
export const getCharacters = <ThrowOnError extends boolean = false>(options: Options<GetCharactersData, ThrowOnError>) => (options.client ?? client).post<GetCharactersResponses, unknown, ThrowOnError>({
    url: '/char',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get character by id
 */
export const getCharacter = <ThrowOnError extends boolean = false>(options: Options<GetCharacterData, ThrowOnError>) => (options.client ?? client).get<GetCharacterResponses, unknown, ThrowOnError>({ url: '/char/{id}', ...options });

/**
 * Get Combo Characters
 */
export const getComboCharacters = <ThrowOnError extends boolean = false>(options: Options<GetComboCharactersData, ThrowOnError>) => (options.client ?? client).post<GetComboCharactersResponses, unknown, ThrowOnError>({
    url: '/char/combo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get character synergy
 */
export const getCharacterSynergy = <ThrowOnError extends boolean = false>(options: Options<GetCharacterSynergyData, ThrowOnError>) => (options.client ?? client).post<GetCharacterSynergyResponses, unknown, ThrowOnError>({
    url: '/char/{id}/synergy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get market region config
 */
export const getMarketRegion = <ThrowOnError extends boolean = false>(options?: Options<GetMarketRegionData, ThrowOnError>) => (options?.client ?? client).get<GetMarketRegionResponses, unknown, ThrowOnError>({ url: '/market/region', ...options });

/**
 * Get user wallet
 */
export const getWallet = <ThrowOnError extends boolean = false>(options?: Options<GetWalletData, ThrowOnError>) => (options?.client ?? client).get<GetWalletResponses, unknown, ThrowOnError>({ url: '/market/wallet', ...options });

/**
 * Get market profile
 */
export const getMarketProfile = <ThrowOnError extends boolean = false>(options?: Options<GetMarketProfileData, ThrowOnError>) => (options?.client ?? client).get<GetMarketProfileResponses, unknown, ThrowOnError>({ url: '/market/profile', ...options });

/**
 * Confirm to become market participant
 */
export const confirmMarketProfile = <ThrowOnError extends boolean = false>(options: Options<ConfirmMarketProfileData, ThrowOnError>) => (options.client ?? client).post<ConfirmMarketProfileResponses, unknown, ThrowOnError>({
    url: '/market/profile/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get item list
 */
export const getMarketItems = <ThrowOnError extends boolean = false>(options?: Options<GetMarketItemsData, ThrowOnError>) => (options?.client ?? client).get<GetMarketItemsResponses, unknown, ThrowOnError>({ url: '/market/item', ...options });

/**
 * Request to sell an item
 */
export const sellItem = <ThrowOnError extends boolean = false>(options: Options<SellItemData, ThrowOnError>) => (options.client ?? client).post<SellItemResponses, unknown, ThrowOnError>({
    url: '/market/item/sell',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request to buy an item
 */
export const buyItem = <ThrowOnError extends boolean = false>(options: Options<BuyItemData, ThrowOnError>) => (options.client ?? client).post<BuyItemResponses, unknown, ThrowOnError>({
    url: '/market/item/buy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get transaction list
 */
export const getMarketTransactions = <ThrowOnError extends boolean = false>(options: Options<GetMarketTransactionsData, ThrowOnError>) => (options.client ?? client).post<GetMarketTransactionsResponses, unknown, ThrowOnError>({
    url: '/market/transaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request to cancel a transaction
 */
export const cancelMarketTransaction = <ThrowOnError extends boolean = false>(options: Options<CancelMarketTransactionData, ThrowOnError>) => (options.client ?? client).post<CancelMarketTransactionResponses, unknown, ThrowOnError>({
    url: '/market/transaction/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
